/*
 * @Author: 辰乐 chenxinyu@cai-inc.com
 * @Date: 2024-01-08 11:05:35
 * @LastEditors: 辰乐 chenxinyu@cai-inc.com
 * @LastEditTime: 2024-01-15 10:46:25
 * @FilePath: /zcy-claim-front/src/routes/CarManage/services/index.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { query, request } from 'src/utils/request'; // 单位信息查询

// 获取车辆管理列表
export const reqVehicleList = async data => {
  return query('/zlb/api/expense/vehicle/list', {
    data,
    method: 'POST',
  });
};

// 同步ETC账单
export const reqVehicleSyncEtc = async data => {
  return request('/zlb/api/expense/vehicle/sync/etc', {
    data,
    method: 'POST',
  });
};

// 校验车俩是否为一
export const reqVehicleRepeatCheck = async data => {
  return request('/zlb/api/expense/vehicle/repeat/check', {
    data,
    method: 'POST',
  });
};

// 车辆信息保存
export const reqVehicleSave = async data => {
  return request('/zlb/api/expense/vehicle/save', {
    data,
    method: 'POST',
  });
};

// 获取车辆详情
export const reqVehicleDetail = async params => {
  return query('/zlb/api/expense/vehicle/detail', {
    params,
  });
};

// 车辆绑定ETC
export const reqVehicleBind = async data => {
  return request('/zlb/api/expense/vehicle/bind', {
    data,
    method: 'POST',
  });
};

// 处理车辆
export const reqVehicleHandle = async data => {
  return request('/zlb/api/expense/vehicle/handle', {
    data,
    method: 'POST',
  });
};

// 获取车辆管理列表
export const reqEtcBillList = async data => {
  return query('/zlb/api/expense/public/bill/list', {
    data,
    method: 'POST',
  });
};
// 车辆管理导入确认
export const reqvehicleConfirm = async data => {
  return query('/zlb/api/expense/imports/vehicle/confirm', {
    data,
    method: 'POST',
  });
};

//查询车辆批量导入模板
export const getVehicleTemplate = async params => {
  return request('/zlb/api/expense/imports/import/template-query', {
    method: 'GET',
    params,
  });
};
